"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../../context");
const Checkbox_1 = tslib_1.__importDefault(require("../../../../ui-lib/Inputs/Checkbox"));
const ErrorBoundary_1 = require("../../../ErrorBoundary");
const ModularEchoCancellationCheckbox = (0, mobx_react_lite_1.observer)(({ classes, ...props }) => {
    /**
     * Component Name (for error msg)
     */
    const componentName = "<EchoCancellationCheckbox/>";
    /**
     * Access EncoderUiContext & destructure API state
     */
    const ctx = (0, react_1.useContext)(context_1.EncoderUiContext);
    /**
     * Throw error (and trigger ErrorBoundary) if store is undefined.
     * */
    (0, ErrorBoundary_1.useUndefinedStoreError)((ctx === null || ctx === void 0 ? void 0 : ctx.mediaStreamController) != null, componentName);
    const toggleEchoCancellation = () => {
        ctx.mediaStreamController.echoCancellation = !ctx.mediaStreamController.echoCancellation;
    };
    /**
     * Wrap onChange function in global Error handler (to trigger ErrorBoundary).
     * */
    const handleInputChange = (0, ErrorBoundary_1.useUIEventError)(toggleEchoCancellation, componentName);
    return (react_1.default.createElement(Checkbox_1.default, { ...props, classes: classes === null || classes === void 0 ? void 0 : classes.echoCancellationCheckbox, label: "Echo Cancellation", disabled: !ctx.mediaStreamController.supportsEchoCancellation(), checked: ctx.mediaStreamController.echoCancellation === true, onChange: handleInputChange, title: !ctx.mediaStreamController.supportsEchoCancellation()
            ? "Your browser does not support echo cancellation"
            : undefined }));
});
const EchoCancellationCheckboxWithErrorBoundary = ({ classes, ...props }) => {
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => (react_1.default.createElement(Checkbox_1.default, { ...props, disabled: true, classes: classes === null || classes === void 0 ? void 0 : classes.echoCancellationCheckbox, label: "Echo Cancellation Unavailable" })) },
        react_1.default.createElement(ModularEchoCancellationCheckbox, { classes: classes, ...props })));
};
exports.default = EchoCancellationCheckboxWithErrorBoundary;
//# sourceMappingURL=EchoCancellationCheckbox.js.map